export default __webpack_public_path__ + "static/media/free-icon-menu-1828551.555334e0.svg";